import React, { useMemo, useRef } from "react";
import ReactECharts from "echarts-for-react";

const EMPTY_DATA = [];

export default function ActiveHistogram({ data }) {
    const safeData = Array.isArray(data) ? data : EMPTY_DATA;
    const chartRef = useRef(null);

    // агрегация по active
    const grouped = useMemo(() => {
        return safeData.reduce((acc, item) => {
            acc[item.active] = (acc[item.active] || 0) + (item.cnt || 0);
            return acc;
        }, {});
    }, [safeData]);

    const total = useMemo(
        () => Object.values(grouped).reduce((a, b) => a + b, 0),
        [grouped]
    );

    const series = Object.entries(grouped).map(([key, value]) => {
        const percent = total > 0 ? (value / total) * 100 : 0;
        return {
            name: key,
            type: "bar",
            stack: "total",
            data: [{ value: percent, raw: value }],
            label: {
                show: true,
                position: "inside",
                formatter: () => `${key}: ${percent.toFixed(1)}% (${value})`,
            },
        };
    });

    const option = {
        legend: {
            bottom: 0,
            left: "center",
            orient: "horizontal",
            itemWidth: 14,
            itemHeight: 14,
        },

        tooltip: {
            trigger: "item",
            formatter: (params) => {
                const percent = params.value;
                const raw = params?.data?.raw;
                return `
                    <b>${params.seriesName}</b><br/>
                    ${Number(percent).toFixed(1)}%<br/>
                    ${raw} шт.
                `;
            },
        },

        grid: {
            left: 40,
            right: 40,
            top: 24,
            bottom: 40,
        },

        xAxis: {
            type: "value",
            max: 100,
            axisLabel: { formatter: "{value}%" },
        },

        yAxis: {
            type: "category",
            data: [""], // одна полоса
        },

        series,
    };

    return (
        <ReactECharts
            ref={chartRef}
            option={option}
            style={{ height: 280, width: "100%" }}
        />
    );
}
